import React from "react";

import ConfirmationsModal from "@/components/molecules/quote-section/edit-quote-section/confirmation-modal";
import { useFetchUnsavedChangesWarning } from "@/hooks/magnolia/use-fetch-unsaved-changes-warning";

type UnSavedChangesWarningMessageProps = {
  isOpen: boolean;
  onContinueClick: () => void;
  setIsOpen: (isOpen: boolean) => void;
};

function UnSavedChangesWarningMessage({
  isOpen,
  onContinueClick,
  setIsOpen,
}: Readonly<UnSavedChangesWarningMessageProps>) {
  const { data: warningMessage } = useFetchUnsavedChangesWarning();

  return (
    <ConfirmationsModal
      modalTitle={warningMessage.modalTitle ?? ""}
      modalDescription={warningMessage.modalDescription ?? ""}
      backButtonLabel={warningMessage.backButtonLabel ?? ""}
      ctaButtonLabel={warningMessage.ctaButtonLabel ?? ""}
      handleConfirmBtnClick={onContinueClick}
      handleCancelmBtnClick={() => {
        setIsOpen(false);
      }}
      isOpen={isOpen}
      isShowDescription={false}
    />
  );
}

export default UnSavedChangesWarningMessage;
